var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_128_2",
    "data-name": "Componente 128 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.99,
    height: 126.99,
    viewBox: "0 0 126.99 126.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M63.495,0A63.495,63.495,0,1,1,0,63.495,63.495,63.495,0,0,1,63.495,0Z",
    fill: "rgba(97,97,97,0.05)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backup_black_24dp_1_",
    "data-name": "backup_black_24dp (1)",
    transform: "translate(25.398 25.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud_done_black_24dp_1_",
    "data-name": "cloud_done_black_24dp (1)",
    transform: "translate(0.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_488",
    "data-name": "Trazado 488",
    d: "M0,0H75.316V75.316H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_489",
    "data-name": "Trazado 489",
    d: "M60.724,22.955a23.513,23.513,0,0,0-43.935-6.276,18.821,18.821,0,0,0,2.04,37.533h40.8a15.646,15.646,0,0,0,1.1-31.256ZM33.61,42.568a3.125,3.125,0,0,1-4.425,0l-6.59-6.559a3.129,3.129,0,1,1,4.425-4.425l4.362,4.362L45.441,21.888a3.129,3.129,0,1,1,4.425,4.425L33.61,42.568Z",
    transform: "translate(0 8.553)",
    fill: "#2dc409"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1537",
    "data-name": "Grupo 1537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_486",
    "data-name": "Trazado 486",
    d: "M0,0H76.194V76.194H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSave);
export default __webpack_public_path__ + "static/media/uploadSave.2caae61df77fdb1f95b5d94315d31f8c.svg";
export { ForwardRef as ReactComponent };